import React from 'react';
import OGGameStopPackages from './components/OGGameStopPackages';

function App() {
  return (
    <div className="App">
      <OGGameStopPackages />
    </div>
  );
}

export default App;
